(function () {
  function bindLoopVariantSync() {
    var selector = document.querySelector('variant-radios, variant-selects');
    if (!selector) return;

    selector.addEventListener('change', function () {
      setTimeout(function () {
        if (!window.renderLoopWidget || !window.LOOP_WIDGET) return;
        var productId = Object.keys(window.LOOP_WIDGET)[0];
        if (productId) window.renderLoopWidget(productId);
      }, 150);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindLoopVariantSync);
  } else {
    bindLoopVariantSync();
  }
})();